




































import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";
import * as Transportes from '@lib/Expedicion/Transportes';
import { Transporte } from '@lib/Expedicion/Transportes';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {


    @Prop( { type: Transporte } )
    public value: Transporte;

    @Watch( 'value', { immediate: true } )
    onIndex() {
        this.Selected = this.value;
    }

    constructor() {
        super();
    }

    public Items: Transportes.Transporte[] = [];

    public Busqueda: string = '';
    @Watch( 'Busqueda' )
    public async Buscar() {

        if ( this.Estado === 'cargando' )
            return;

        this.Estado = 'cargando';

        let e = await Transportes.Transporte.find( { q: this.Busqueda } );
        this.Items = e.Items;

        this.Estado = 'ok';
    }




    public selected: Transporte | null = null;
    public get Selected(): Transporte | null {
        return this.selected;
    }
    public set Selected( x: Transporte | null ) {
        this.selected = x;
        this.$emit( 'input', this.Selected );
    }

    public async onLostFocus( event: any ) {

    }

    public Estado: 'cargando' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';
}
